import { MailboxTable } from "@/components/mailbox-table";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/mailbox",
)({
  component: RouteComponent,
  pendingComponent: () => (
    <div>
      <div className="p-4 border rounded-md flex items-center space-x-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Cargando...</span>
      </div>
    </div>
  ),
});

function RouteComponent() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Bandeja de entrada HSE</h1>
      <MailboxTable mode="company" />
    </div>
  );
}
